// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"multipleChoiceNoteFilter_mulitpleDropdown__24yU7"};